import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "radio" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "invisible whitespace-nowrap w-0" }, "RADIO BUTTON", -1)
const _hoisted_3 = ["checked"]

import { Icon } from '@iconify/vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    checked: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      class: "radio__input",
      type: "radio",
      disabled: "",
      checked: __props.checked
    }, null, 8, _hoisted_3),
    _createElementVNode("span", {
      class: _normalizeClass(["radio__mark", { 'radio__mark--checked': __props.checked }])
    }, [
      (__props.checked)
        ? (_openBlock(), _createBlock(_unref(Icon), {
            key: 0,
            icon: "fluent:checkmark-12-filled",
            class: "text-white",
            width: "10px"
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})